import { Table, Typography } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import axiosInstance from "../../axios";

type PublicTutorApplication = {
  id: number;
  dealings_id: number;
  job_title?: string | null;
  first_name: string;
  last_name: string;
  gender?: string | null;
  mobile: string;
  address?: string | null;
  created_at?: string;
  submittedAt?: string;
};

type PublicTutorTabProps = {
  dealingsId: string | number;
};

export function PublicTutorTab({ dealingsId }: PublicTutorTabProps) {
  const [data, setData] = useState<PublicTutorApplication[]>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  const fetchData = async (page = 1, limit = 25) => {
    setLoading(true);
    try {
      const response = await axiosInstance.get("/v1/cre/job-applications", {
        params: { page, limit, dealId: dealingsId },
      });
      const rows = response.data?.data || [];
      setData(
        rows.map((item: PublicTutorApplication) => ({
          ...item,
          submittedAt: item.created_at
            ? dayjs(item.created_at).format("DD MMM YYYY, hh:mm A")
            : "",
        })),
      );
      setPagination({
        current: page,
        pageSize: limit,
        total: response.data?.meta?.total || 0,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealingsId]);

  const columns = [
    {
      title: "Name",
      key: "name",
      render: (_: unknown, record: PublicTutorApplication) =>
        `${record.first_name || ""} ${record.last_name || ""}`.trim() || "-",
    },
    {
      title: "Gender",
      dataIndex: "gender",
      key: "gender",
      width: 110,
      render: (value: string) => value || "-",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      width: 140,
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      render: (value: string) => value || "-",
    },
    {
      title: "Applied At",
      dataIndex: "submittedAt",
      key: "submittedAt",
      width: 190,
    },
  ];

  return (
    <div className="tail-mt-2">
      <Typography.Text type="secondary">
        Tutors who applied for this job from the public job portal.
      </Typography.Text>
      <Table
        className="tail-mt-3"
        rowKey="id"
        loading={loading}
        columns={columns}
        dataSource={data}
        bordered
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => fetchData(page, pageSize),
        }}
      />
    </div>
  );
}
